import { ItemPricing } from "./ItemPricing";

export class Item {
  constructor() {
    this.Item = "";
    this.Description = "";
    this.Description2 = "";
    this.Pricing = [];
    this.Quantity = 1;
    this.FuturePricing = new ItemPricing();
    this.EffectivePricing = new ItemPricing();
    this.OrderConfigurable = false;
    this.Index = 0;
    this.ConfigHasChanged = false;
    this.HasPricing = false;
  }

  public Item: string;
  public Description: string;
  public Description2: string;
  public SelectionSummary: string;
  public Pricing: ItemPricing[];
  public FuturePricing: ItemPricing;
  public EffectivePricing: ItemPricing;
  public OrderConfigurable: boolean;
  public Quantity: number;
  public Index: number;
  public ConfigHasChanged: boolean;
  public ItemStatus: string;
  public HasPricing: boolean;

  BuildPricing() {
    if (this.Pricing && this.Pricing.length > 0) {
      this.HasPricing = true;
      var currentDate = new Date();
      this.FuturePricing = this.Pricing.filter((price) => { return new Date(price.EffectDate.toString()).getTime() > currentDate.getTime() })[0];
      var futureDate = new Date();
      if (!this.FuturePricing) {
        this.FuturePricing = null;
      }
      else {
        futureDate = new Date(this.FuturePricing.EffectDate);
      }
      var filteredDates = [];
      this.Pricing.forEach((price) => {
        var curDate = new Date(price.EffectDate.toString());
        if (curDate.getTime() != futureDate.getTime() && curDate.getTime() <= currentDate.getTime()) {
          filteredDates.push(price.EffectDate);
        }
      });


      var dateToGrab = new Date(filteredDates[0]);

      this.EffectivePricing = this.Pricing.filter((price) => {
        var curPricingDate = new Date(price.EffectDate.toString());
        return curPricingDate.getMonth() == dateToGrab.getMonth() && curPricingDate.getFullYear() == dateToGrab.getFullYear() && curPricingDate.getDay() == dateToGrab.getDay();
      })[0];

      this.Description = this.EffectivePricing.Description;
      this.Description2 = this.EffectivePricing.Description2;
    }
    else {
      this.HasPricing = false;
    }
  }
}
